module.exports = __webpack_public_path__ + "static/media/logo.38bb6a7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 401
// module chunks = 0